import React from 'react';
import ReactDOM from 'react-dom/client';
import './apiMode';
import './hideScrollbar.css';
import App from './App';
import './components/controls.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
